module.exports = __webpack_public_path__ + "img/neo-icon-green.fbf49970.svg";